'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailComponent = exports.orderDetailComponent = {
    template: require('./order-detail.html'),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "authService", "config", "$stateParams", "orderService", "Analytics", function orderDetailController(common, gettextCatalog, authService, config, $stateParams, orderService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.setOrderDeliveryDate = setOrderDeliveryDate;
        vm.updateOrderDeliverDateErrors = [];
        vm.updatingOrderDate = false;

        function init() {
            common.navigationMenu.clearActiveMenu();
            var pageTitle = vm.order.referenceNumber ? gettextCatalog.getString('Order - noun') + ' ' + vm.order.referenceNumber : gettextCatalog.getString('Order - noun');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/orders/' + vm.order.id, pageTitle);
        }

        function getDownloadUrl() {
            return config.webApiBaseUrl + ('report/orderDetail/' + vm.order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function setOrderDeliveryDate(newDeliveryDate) {
            vm.updatingOrderDate = true;
            orderService.setOrderDeliveryDate(vm.order, newDeliveryDate).then(function (order) {
                vm.order = order;
                vm.updatingOrderDate = false;
                vm.updateOrderDeliverDateErrors = [];
            }).catch(function (err) {
                vm.updateOrderDeliverDateErrors = err.data.errors;
                vm.updatingOrderDate = false;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/order-detail.js
// module id = 868
// module chunks = 0